import { LoginService } from '../../services/auth.service';
import { ApiService } from './../../api.service';
import { Component, OnInit, Inject } from '@angular/core';
import {
  SocialUser,
  AuthService,
  GoogleLoginProvider,
  FacebookLoginProvider,
  LinkedInLoginProvider,
} from 'angularx-social-login';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
  user: SocialUser;
  body = 'Start your journey here';
  loginIssue = `Please allow Pop ups as its must to Login our application.. Please Try Again logging in`;
  isSubmitting: boolean;
  constructor(
    public dialogRef: MatDialogRef<SignInComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public authService: AuthService,
    public api: ApiService,
    public login: LoginService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.authService.authState.subscribe(user => {
      this.user = user;
    });
  }

  openInfoDialog(type: string) {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      width: '300px',
      data: type,
    });
  }

  signInWithGoogle(): void {
    this.isSubmitting = true;
    this.authService
      .signIn(GoogleLoginProvider.PROVIDER_ID)
      .then(data => {
        this.isSubmitting = false;
        this.dialogRef.close(data);
      })
      .catch(err => {
        this.isSubmitting = false;
        this.dialogRef.close(true);
        this.openInfoDialog(this.loginIssue);
        console.log(err, 'google err');
      });
  }

  signInWithFB(): void {
    this.isSubmitting = true;
    this.authService
      .signIn(FacebookLoginProvider.PROVIDER_ID)
      .then(data => {
        this.isSubmitting = false;
        this.dialogRef.close(data);
      })
      .catch(err => {
        this.isSubmitting = false;
        this.dialogRef.close(true);
        this.openInfoDialog(this.loginIssue);
        console.log(err, 'FB err');
      });
  }

  signInWithLinkedIn(): void {
    this.isSubmitting = true;
    this.authService
      .signIn(LinkedInLoginProvider.PROVIDER_ID)
      .then(data => {
        this.isSubmitting = false;
        this.dialogRef.close(data);
      })
      .catch(err => {
        this.isSubmitting = false;
        this.dialogRef.close(true);
        this.openInfoDialog(this.loginIssue);
        console.log(err, 'LinkedIn err');
      });
  }

  signOut(): void {
    this.isSubmitting = true;
    this.authService.signOut();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
